const desktopNavMenuButtons = document.querySelectorAll(
  "#primary-menu .menu-item-has-children .mega-menu-one__button"
);
const desktopNavHeader = document.querySelector(".site-header");

const toggleDesktopMenuItem = (navButton) => {
  const buttonListElement = navButton.closest(".menu-item-has-children");
  const itemMegaMenu = buttonListElement.querySelector(".mega-menu-one");

  if (!buttonListElement || !itemMegaMenu) return;

  desktopNavMenuButtons.forEach((otherNavButton) => {
    const otherButtonListElement = otherNavButton.closest(
      ".menu-item-has-children"
    );
    const otherItemMegaMenu =
      otherButtonListElement.querySelector(".mega-menu-one");

    if (otherButtonListElement !== buttonListElement) {
      otherButtonListElement.classList.remove("open");
      otherItemMegaMenu.setAttribute("data-open", "false");
      desktopNavHeader.classList.remove("mega-menu-open");
    }
  });

  buttonListElement.classList.toggle("open");
  const isOpen = itemMegaMenu.getAttribute("data-open") === "true";
  const searchIcon = document.querySelector(".navbar-one__search-btn");
  itemMegaMenu.setAttribute("data-open", isOpen ? "false" : "true");

  if (itemMegaMenu.dataset.open === "true") {
    document.body.classList.remove("navSearchOpen");
    searchIcon.classList.remove("close");
    desktopNavHeader.classList.add("mega-menu-open");
  } else {
    desktopNavHeader.classList.remove("mega-menu-open");
  }
};

desktopNavMenuButtons.forEach((navItemButton) => {
  navItemButton.addEventListener("mouseover", (e) => {
    if (!navItemButton.parentNode.classList.contains("open")) {
      e.preventDefault();
      toggleDesktopMenuItem(navItemButton);
    }
  });

  // navItemButton.addEventListener("focus", (e) => {
  //   if (!navItemButton.parentNode.classList.contains("open")) {
  //     e.preventDefault();
  //     toggleDesktopMenuItem(navItemButton);
  //   }
  // });

  // navItemButton.addEventListener("click", (e) => {
  //   toggleDesktopMenuItem(navItemButton);
  // });
});

desktopNavMenuButtons.forEach((navItemButton) => {
  const menuDropdown = navItemButton.nextElementSibling;
  if (menuDropdown) {
    menuDropdown.addEventListener("focusout", (e) => {
      // Check if the mouse is still within the menuDropdown element
      if (!menuDropdown.contains(e.relatedTarget)) {
        e.preventDefault();
        toggleDesktopMenuItem(navItemButton);
      }
    });
    menuDropdown.addEventListener("mouseout", (e) => {
      // Check if the mouse is still within the menuDropdown element
      if (!menuDropdown.contains(e.relatedTarget)) {
        e.preventDefault();
        toggleDesktopMenuItem(navItemButton);
      }
    });
  }
});

// The search container transitions out of visibility:hidden, and focus() is a
// no-op while it is still hidden, so wait for that transition to finish. The
// timer covers transitions being disabled, where transitionend never fires.
const focusWhenVisible = (input) => {
  if (!input) return;
  const container = input.closest(".search-container");
  if (!container) {
    input.focus();
    return;
  }
  const focus = () => input.focus();
  container.addEventListener("transitionend", focus, { once: true });
  setTimeout(focus, 400);
};

// search button logic
const searchButton = desktopNavHeader?.querySelector(".navbar-one__search-btn");
const search_close = desktopNavHeader?.querySelector(".search-container__close-col");

if (search_close) {
  search_close.addEventListener("click", () => {
    document.body.classList.toggle("navSearchOpen");
    const searchInput = document.querySelector("#search-input");
    const hamburgerMenu = document.querySelector(".navbar-one__hamburger");
    const menuDropdowns = document.querySelectorAll(".navbar-one__top-level");

    search_close.classList.toggle("close");

    menuDropdowns.forEach((dropdown) => {
      const menuDropdown = dropdown.querySelector(".mega-menu-one");
      menuDropdown?.removeAttribute("data-open");
      dropdown.classList.remove("open");
    });

    document.body.classList.remove("overflow-hidden");
    const mobileMenu = document.querySelector(".navbar-one__mobile");
    const desktopMenu = document.querySelector(".navbar-one__desktop");

    mobileMenu?.removeAttribute("data-open");
    desktopMenu?.removeAttribute("data-open");
    hamburgerMenu.classList.remove("menu-open");
    desktopNavHeader.classList.remove("mega-menu-open");
    desktopNavHeader.classList.remove("mobile-menu-open");

    if (document.body.classList.contains("navSearchOpen")) {
      focusWhenVisible(searchInput);
    }
  });
}

if (searchButton) {
  searchButton.addEventListener("click", () => {
    document.body.classList.toggle("navSearchOpen");
    const searchInput = document.querySelector("#search-input");
    const hamburgerMenu = document.querySelector(".navbar-one__hamburger");
    const menuDropdowns = document.querySelectorAll(".navbar-one__top-level");

    searchButton.classList.toggle("close");

    menuDropdowns.forEach((dropdown) => {
      const menuDropdown = dropdown.querySelector(".mega-menu-one");
      menuDropdown?.removeAttribute("data-open");
      dropdown.classList.remove("open");
    });

    document.body.classList.remove("overflow-hidden");
    const mobileMenu = document.querySelector(".navbar-one__mobile");
    const desktopMenu = document.querySelector(".navbar-one__desktop");

    mobileMenu?.removeAttribute("data-open");
    desktopMenu?.removeAttribute("data-open");
    hamburgerMenu.classList.remove("menu-open");
    desktopNavHeader.classList.remove("mega-menu-open");
    desktopNavHeader.classList.remove("mobile-menu-open");

    if (document.body.classList.contains("navSearchOpen")) {
      focusWhenVisible(searchInput);
    }
  });
}

document.addEventListener('DOMContentLoaded', function() {
  const subItemLinks = document.querySelectorAll('.mega-menu-one__list-item');

  subItemLinks.forEach(function(link) {
    // Add mouseenter event to each link
    link.addEventListener('mouseenter', function() {
      const parentItem = link.closest('.mega-menu-one__list-item:not(.ignore-hover)');
      if (parentItem) {
        parentItem.classList.add('hovered');
      }

      const allItems = document.querySelectorAll('.mega-menu-one__list-item:not(.ignore-hover)');
      allItems.forEach(function(item) {
        if (item !== parentItem) {
          item.classList.add('not-hovered');
        }
      });
    });

    link.addEventListener('mouseleave', function() {
      const parentItem = link.closest('.mega-menu-one__list-item:not(.ignore-hover)');
      if (parentItem) {
        parentItem.classList.remove('hovered');
      }

      const allItems = document.querySelectorAll('.mega-menu-one__list-item:not(.ignore-hover)');
      allItems.forEach(function(item) {
        item.classList.remove('not-hovered');
      });
    });
  });
});


// Try immediately executing code
const searchIcon = document.querySelector('.search-icon');
const searchForm = document.querySelector('.archive-page-search-form');



if (searchIcon && searchForm) {
    searchIcon.addEventListener('click', function(e) {
        e.preventDefault();
        
        const searchInput = searchForm.querySelector('input[type="search"]');
        if (!searchInput.value.trim()) {
            return;
        }
        
        searchForm.submit();
    });
}

// Alternatively, try using window.onload
window.onload = function() {
    const searchIcon = document.querySelector('.search-icon');
    const searchForm = document.querySelector('.archive-page-search-form');
    
    if (searchIcon && searchForm) {
        searchIcon.addEventListener('click', function(e) {
            e.preventDefault();
            
            const searchInput = searchForm.querySelector('input[type="search"]');
            if (!searchInput.value.trim()) {
                return;
            }
            
            searchForm.submit();
        });
    }
};